import { Button, Result } from "antd";
import { ApartmentOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import { usePermission } from "@/hooks";

/**
 * Shown in place of a unit-scoped page while the installation has no
 * production unit. Products, recipes, equipment, calendars, orders and plans
 * all belong to a unit, so the first step on a fresh database is a plant
 * and a unit — said plainly, instead of "Unknown production unit".
 */
export default function NoUnitNotice() {
  const navigate = useNavigate();
  const { can } = usePermission();
  const isAdmin = can("org", "update");

  return (
    <div className="p-6">
      <Result
        icon={<ApartmentOutlined style={{ color: "var(--accent)" }} />}
        title="Add a plant and a production unit first"
        subTitle={
          isAdmin
            ? "No production unit has been set up yet. Products, recipes, equipment, calendars, orders and plans all belong to a production unit — add a plant, then a production unit under it, and this page opens for that unit."
            : "No production unit has been set up yet. Products, recipes, equipment, calendars, orders and plans all belong to a production unit — ask your administrator to add a plant and a production unit."
        }
        extra={
          isAdmin && (
            <Button type="primary" onClick={() => navigate("/admin/plants")}>
              Go to Plants
            </Button>
          )
        }
      />
    </div>
  );
}
